export const SK_AI_INDEX_URL = 'https://sk-ai.com'; 			    //正式
//export const SK_AI_INDEX_URL = 'http://test.sk-ai.com'; 			//测试


// WEBPACK FOOTER //
// ./src/api/api.js